import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { Brand } from "@/components/Brand";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate("/team", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email.trim(), password);
      toast.success(u.must_change_password ? "Welcome! Please set your own password." : `Welcome back, ${u.name}`);
      navigate(u.must_change_password ? "/team/profile" : "/team", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white grain">
      <div className="mx-auto flex min-h-screen max-w-6xl flex-col px-4 py-6 sm:px-6 lg:flex-row lg:items-center lg:gap-16">
        <div className="flex-1 py-8 lg:py-0">
          <Brand dark subtitle="Team dashboard" />
          <h1 className="mt-10 font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
            Clear the queue.
            <br />
            <span className="text-[#FACC15]">Beat the SLA.</span>
          </h1>
          <p className="mt-6 max-w-md text-base text-zinc-400 sm:text-lg">Private team area for Virality School support executives and admins. Pick up tickets, resolve them, and keep escalations at zero.</p>
        </div>

        <form onSubmit={submit} className="w-full max-w-md rounded-2xl border-2 border-[#FACC15] bg-white p-6 text-black sm:p-8 fade-up" style={{ boxShadow: "6px 6px 0 0 #FACC15" }} data-testid="login-form">
          <h2 className="font-display text-2xl font-bold">Team login</h2>
          <p className="mt-1 text-sm text-zinc-600">Use the account your admin created for you.</p>
          <div className="mt-6 space-y-5">
            <div>
              <label className="field-label">Email</label>
              <input className="field-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" autoComplete="email" required />
            </div>
            <div>
              <label className="field-label">Password</label>
              <input className="field-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" autoComplete="current-password" required />
            </div>
            {error && (
              <p className="rounded-lg border-2 border-[#DC2626] bg-[#FEF2F2] px-3 py-2 text-sm font-semibold text-[#B91C1C]" data-testid="login-error">
                {error}
              </p>
            )}
            <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit-button">
              {busy ? "Signing in…" : "Sign in"}
            </button>
            <Link to="/forgot-password" className="block text-center text-sm font-bold underline" data-testid="forgot-password-link">Forgot password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
